import IconButton from "@/Components/IconButton/IconButton";
import { useSetModal } from "@/shared/atoms/useModal";
import { useTranslation } from "react-i18next";
import useMap from "./useMap";
import Tooltip from "@/Components/Tooltip/Tooltip";

const MapsFooter = () => {
  const { duplicateMap } = useMap();
  const setModal = useSetModal();
  const { t } = useTranslation("", { keyPrefix: "maps" });
  return (
    <div
      className="flex gap-8 rounded-[0.4rem] border border-grey-blue-light bg-[white] p-4">
      
      <Tooltip content={t("addMap")}><div><IconButton onClick={() => setModal("map")}
            variants="plus"
            size="small" /></div></Tooltip>
      

      <Tooltip content={t("copyMap")}><div><IconButton onClick={duplicateMap}
            variants="copy"
            size="small" /></div></Tooltip>
      
    </div>);

};

export default MapsFooter;